/* Boni cart drawer controller — 2026-09-01.

   Hand-written theme asset (NOT built from JSX, same as boni-plan.js and
   boni-guide.js). Loaded from theme.liquid.

   Everything is delegated from `document`, on purpose: after every cart mutation the
   whole drawer section is re-rendered through Shopify's Section Rendering API and its
   DOM is replaced, so any listener bound directly to a button would die on the first
   swap.

   Progressive enhancement throughout. If fetch fails or JS never runs, the
   add-to-cart form posts to /cart/add and the cart links navigate to /cart, which
   renders the same panel. Nothing here is load-bearing for making a purchase. */
(function () {
  var SECTION = 'boni-cart-drawer';
  var openTimer = null;

  /* The step guide (assets/boni-guide.js) attaches KORAK 3 inside this drawer, and
     the panel is replaced on every mutation, so it needs to know when to re-attach.
     Events rather than a direct call: neither file should require the other. */
  function emit(name) {
    try { document.dispatchEvent(new CustomEvent(name)); } catch (e) {}
  }

  function drawer() { return document.getElementById('bc-drawer'); }

  /* The cadence note names the dog when the wizard handoff stored one (localStorage
     boni_plan.dog, same source as boni-guide.js). The name came from a URL param, so
     textContent only. Nominative slot: "koliko Hugo stvarno jede". */
  function fillDog(root) {
    var dog = '';
    try { dog = ((JSON.parse(localStorage.getItem('boni_plan') || '{}') || {}).dog || '').trim(); } catch (e) {}
    if (!dog) return;
    var nodes = (root || document).querySelectorAll('[data-bc-dog]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = dog;
  }
  function scrim() { return document.querySelector('.bc-scrim'); }

  function openDrawer() {
    var d = drawer(), s = scrim();
    if (!d) return false;
    d.hidden = false; if (s) s.hidden = false;
    /* one frame between display and the class, or the transition never plays */
    clearTimeout(openTimer);
    openTimer = setTimeout(function () {
      d.classList.add('is-open'); if (s) s.classList.add('is-open');
      document.documentElement.classList.add('bc-locked');
      var c = d.querySelector('.bc-close'); if (c) c.focus();
      emit('boni:cart-open');
    }, 20);
    return true;
  }

  function closeDrawer() {
    var d = drawer(), s = scrim();
    if (!d) return;
    d.classList.remove('is-open'); if (s) s.classList.remove('is-open');
    document.documentElement.classList.remove('bc-locked');
    emit('boni:cart-close');
    setTimeout(function () {
      if (d.classList.contains('is-open')) return;   /* re-opened meanwhile */
      d.hidden = true; if (s) s.hidden = true;
    }, 260);
  }

  /* Re-render from the server so prices, the automatic discount and the cadence
     options are always Liquid's answer, never something painted by hand here. */
  function refresh() {
    var d = drawer();
    if (!d) { window.location.reload(); return Promise.resolve(); }
    return fetch('/?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j[SECTION];
        if (!html) return;
        var box = document.createElement('div');
        box.innerHTML = html;
        var freshPanel = box.querySelector('.bc-panel');
        var freshHead  = box.querySelector('.bc-head-t');
        var curPanel   = d.querySelector('.bc-panel');
        var curHead    = d.querySelector('.bc-head-t');
        if (freshPanel && curPanel) curPanel.parentNode.replaceChild(freshPanel, curPanel);
        if (freshHead && curHead) curHead.innerHTML = freshHead.innerHTML;
        syncBadges(freshPanel ? freshPanel.getAttribute('data-count') : null);
        fillDog(freshPanel);
        emit('boni:cart-render');
      })
      .catch(function () { /* leave the drawer as it was rather than blanking it */ });
  }

  /* Header cart badge. The badge element itself is rendered by the React header
     (boni-web/Sections.jsx), which has no cart data — this file owns that, so it
     fills it. Hidden at 0 rather than showing a "0", which is why the old badge was
     removed in S83. */
  function syncBadges(n) {
    if (n === null || n === undefined) return;
    var count = Number(n) || 0;
    var els = document.querySelectorAll('[data-cart-count]');
    Array.prototype.forEach.call(els, function (e) {
      e.textContent = count;
      e.hidden = count < 1;
    });
  }

  /* First paint: the badge has to be right before anyone touches the cart, and the
     React header mounts after us, so poll briefly for it rather than racing. */
  function primeBadge() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var tries = 0;
        (function place() {
          if (document.querySelector('[data-cart-count]')) return syncBadges(c.item_count);
          if (tries++ < 40) setTimeout(place, 100);
        })();
      })
      .catch(function () { /* a missing badge is never worth an error */ });
  }
  function prime() { primeBadge(); fillDog(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prime);
  else prime();

  function change(line, qty, plan) {
    var body = { line: Number(line), quantity: Number(qty) };
    if (plan !== undefined && plan !== null) body.selling_plan = Number(plan);
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(refresh);
  }

  function busy(on) {
    var d = drawer(); if (d) d.classList.toggle('is-busy', !!on);
  }

  /* ---- add to cart: open the drawer instead of navigating ---- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    /* NOT f.id — a form exposes its named controls as properties on itself, and this
       form has <input name="id"> (the variant), so `f.id` returns that INPUT ELEMENT
       and never the string. That shadowing silently made this handler bail on every
       add-to-cart, so the form posted natively and the page navigated to /cart. Match
       on the selector instead, which nothing can shadow. */
    if (!f || !f.matches || !f.matches('#bs-form')) return;
    if (!drawer()) return;                 /* /cart page: let it post normally */
    e.preventDefault();
    var btn = f.querySelector('button[type=submit]');
    if (btn) btn.classList.add('is-busy');
    var fd = new FormData(f);
    /* an empty selling_plan means one-time; Shopify rejects the empty string */
    if (!fd.get('selling_plan')) fd.delete('selling_plan');
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', body: fd })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return refresh(); })
      .then(function () { openDrawer(); })
      .catch(function () { f.submit(); })   /* fall back to the real page */
      .then(function () { if (btn) btn.classList.remove('is-busy'); });
  });

  /* ---- open from the header cart control ----
     The header is React chrome we do not own here: the cart icon is a <button
     aria-label="Košarica"> whose onClick does window.location.href = '/cart'
     (boni-web/Sections.jsx). A bubble-phase listener loses that race, which is why
     the first version silently navigated to the page instead of opening. So this one
     runs in the CAPTURE phase and stops propagation before React ever sees the
     click. Anchors to /cart are caught the same way, for any other entry point. */
  document.addEventListener('click', function (e) {
    if (!drawer()) return;                       /* /cart page: let links work */
    var t = e.target.closest && e.target.closest(
      'button[aria-label="Košarica"], a[href$="/cart"], a[href="/cart"], [data-boni-cart]');
    if (!t) return;
    e.preventDefault(); e.stopPropagation();
    refresh().then(openDrawer);
  }, true);

  document.addEventListener('click', function (e) {

    if (e.target.closest && e.target.closest('[data-bc-close]')) {
      var keep = e.target.closest('.bc-keep');
      /* "Nastavi kupovati" inside the drawer just closes it; on the /cart page
         there is no drawer, so let the link do its job and go to the catalog. */
      if (keep && !drawer()) return;
      e.preventDefault(); closeDrawer(); return;
    }

    var q = e.target.closest && e.target.closest('.bc-q, .bc-x');
    if (q && !q.disabled) {
      e.preventDefault();
      busy(true);
      change(q.getAttribute('data-line'), q.getAttribute('data-qty'))
        .then(function () { busy(false); })
        .catch(function () { busy(false); window.location.reload(); });
    }
  });

  /* ---- one-off line -> plan line (E&C's "subscribe and save") ----
     Same variant, same quantity, plus a selling_plan. /cart/change.js does the whole
     conversion in one call; the panel re-renders and the line moves into the plan
     group by itself, because the Liquid groups on selling_plan_allocation. */
  document.addEventListener('click', function (e) {
    var u = e.target.closest && e.target.closest('.bc-upsell');
    if (!u || u.disabled) return;
    e.preventDefault();
    u.disabled = true; busy(true);
    change(u.getAttribute('data-line'), u.getAttribute('data-qty'), u.getAttribute('data-plan'))
      .then(function () { busy(false); })
      .catch(function () { busy(false); window.location.reload(); });
  });

  /* ---- group cadence: one rhythm for every plan line ----
     Recharge creates a separate plan object PER PRODUCT, so "Svaki mjesec" is a
     different id on every bag. The control therefore carries a LABEL, and each line
     translates it through its own data-plans map. Lines are changed sequentially
     (Shopify's cart is not safe to mutate in parallel) and the panel re-renders once
     at the end rather than after each one. */
  document.addEventListener('change', function (e) {
    var g = e.target;
    if (!g.classList || !g.classList.contains('bc-gcad-sel')) return;
    var label = g.value;
    g.disabled = true; busy(true);
    var lines = Array.prototype.slice.call(document.querySelectorAll('#bc-drawer .bc-line, .bc-page .bc-line'));
    var jobs = [];
    lines.forEach(function (el) {
      var map = el.getAttribute('data-plans') || '';
      var line = el.getAttribute('data-line');
      map.split('|').forEach(function (entry) {
        var parts = entry.split('::');           /* pad :: planId :: label */
        if (parts.length < 3) return;
        if (parts[2].trim() !== label.trim()) return;
        var qtyEl = el.querySelector('.bc-qn');
        jobs.push({ line: line, qty: qtyEl ? qtyEl.textContent.trim() : 1, plan: parts[1] });
      });
    });
    (function next(i) {
      if (i >= jobs.length) { return refresh().then(function () { busy(false); }); }
      fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(jobs[i].line), quantity: Number(jobs[i].qty), selling_plan: Number(jobs[i].plan) })
      }).then(function () { next(i + 1); })
        .catch(function () { busy(false); window.location.reload(); });
    })(0);
  });

  document.addEventListener('change', function (e) {
    var s = e.target;
    if (!s.classList || !s.classList.contains('bc-cad-sel')) return;
    s.disabled = true; busy(true);
    change(s.getAttribute('data-line'), s.getAttribute('data-qty'), s.value)
      .then(function () { busy(false); })
      .catch(function () { busy(false); window.location.reload(); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* let anything else open it: window.boniOpenCart() */
  window.boniOpenCart = function () { refresh().then(openDrawer); };
})();
